import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { useDroppable } from '@dnd-kit/core';
import LeadCard from './LeadCard';

/**
 * Board column for one lead status. Leads render newest-first.
 */
const LeadColumn = ({ column, leads, getManagerName, onOpenLead }) => {
  const { setNodeRef, isOver } = useDroppable({ id: column.key });

  const sorted = [...leads].sort((a, b) => b.createdAtMs - a.createdAtMs);

  return (
    <Box
      ref={setNodeRef}
      sx={{
        bgcolor: isOver ? '#e8eef5' : '#f4f5f7',
        borderRadius: 1.5,
        border: isOver ? '2px dashed #4C9AFF' : '2px solid transparent',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 200,
        minWidth: 0,
        transition: 'background 150ms, border-color 150ms'
      }}
    >
      <Tooltip title={column.description} placement="top-start">
        <Box sx={{ px: 1.75, pt: 1.75, pb: 1.25, display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: column.color, flexShrink: 0 }} />
          <Typography
            sx={{
              fontSize: '0.75rem',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.08em'
            }}
          >
            {column.label}
          </Typography>
          <Typography sx={{ fontSize: '0.8125rem', fontWeight: 500, color: 'text.secondary', ml: 0.25 }}>
            {leads.length}
          </Typography>
        </Box>
      </Tooltip>

      <Box
        sx={{
          flex: 1,
          minHeight: 60,
          px: 1.25,
          pb: 1.25,
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          overflowY: 'auto'
        }}
      >
        {sorted.map((lead) => (
          <LeadCard
            key={lead.id}
            lead={lead}
            managerName={getManagerName(lead.relationshipManagerUid)}
            onClick={() => onOpenLead(lead)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default LeadColumn;
